<template>
  <el-drawer direction="rtl" v-model="visible" title="帮助中心编辑" size="1240px" :before-close="handleClose">
    <el-form class="mr20" ref="ruleForm" :model="addRow" label-width="100px">
      <form-item-rule label="标题" prop="title">
        <el-input v-model="addRow.title" placeholder="请输入标题"></el-input>
      </form-item-rule>
      <form-item-rule label="内容" prop="content">
        <ueditor ref="ue"></ueditor>
      </form-item-rule>
      <form-item-rule label="排序" prop="sort">
        <el-input-number :min="0" :controls="false" v-model="addRow.sort"></el-input-number>
      </form-item-rule>
    </el-form>
    <template #footer>
          <span class="dialog-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="doSave()">确定</el-button>
          </span>
    </template>
  </el-drawer>
</template>

<script>
import FormItemRule from "/src/components/el/form-item-rule";
import OneDatePicker from "/src/components/base/OneDatePicker";
import Ueditor from "/src/components/base/ueditor";


export default {
  name: "helpAdd",
  components: {FormItemRule, OneDatePicker, Ueditor,},
  data() {
    return {
      visible: false,
      addRow: {}
    }
  },
  mixins: [tableBase],
  methods: {
    handleClose() {
      this.visible = false;
    },
    open(row) {
      this.visible = true;
      if (row) {
        this.addRow = this.copyObj(row);
        this.$nextTick(() => {
          this.$refs.ue.init(row.content);
        })
      } else {
        this.addRow = {title: "", content: "",sort:''};
        this.$nextTick(() => {
          this.$refs.ue.init("");
        })
      }
    },
    doSave() {
      this.addRow.content = this.$refs.ue.getContent();
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.simplePost("/api/mgr/business/content/help/addOrUpdate", this.addRow, () => {
            this.handleClose();
            this.$emit('load')
            this.message("操作成功");
          })
        }
      })
    }
  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>

</style>
